
import { Vue, Component, Prop } from 'vue-property-decorator'

import useragent from '@finance/useragent'

@Component({
  name: 'Common-header',
  components: {
  },
})
export default class CommonHeader extends Vue {
  // 导航初始化模式
  @Prop({
    type: Boolean,
    default: false
  })
  isStatice!: boolean
  @Prop({
    type: String,
    default: ''
  })
  rightBtnText!: string
  @Prop({
    type: Object,
    default: () => {}
  })
  barStyleExt!: any
  @Prop({
    type: String,
    default: ''
  })
  title!: string
  @Prop({
    type: Boolean,
    default: false
  })
  hideService!: boolean

  scrollTop = -1;
  scrollHeight = 1;
  isKaniu = useragent.isKaniu

  get barHeight() {
    return this.$store.getters.toolBarHeight
  }
  get barStyle() {
    if (this.scrollTop > this.scrollHeight || this.isStatice) {
      return {
        height: this.barHeight + 'px',
        background: '#fff',
        boxShadow: '0 0 10px 0 rgba(0,0,0,0.05)',
        ...this.barStyleExt
      }
    } else {
      return {
        height: this.barHeight + 'px',
        background: 'transparent',
        boxShadow: 'none',
        ...this.barStyleExt
      }
    }
  }
  get scroll() {
    if (this.scrollTop > this.scrollHeight || this.isStatice) {
      return true
    } else {
      return false
    }
  }

  public handleBack() {
    this.$emit('back')
  }
  handleRight() {
    this.$emit('rightBtnClick')
  }
  public mounted() {
    window.addEventListener('scroll', this.scrollHandler)
  }
  // public beforeRouteLeave(to: any, from: any, next: any) {
  //   window.removeEventListener('scroll', this.scrollHandler)
  //   next()
  // }
  settimer: any = null
  scrollHandler() {
    const bodyHeight = document.querySelector('body')?.style.height
    clearTimeout(this.settimer)
    this.settimer = setTimeout(() => {
      const scrollTop = document.documentElement.scrollTop || window.scrollY || document.body.scrollTop
      const rect: any = document.querySelector('#member')?.getBoundingClientRect()
      if (rect && rect.bottom <= this.barHeight) {
        this.$emit('showFixed', true)
      } else {
        this.$emit('showFixed', false)
      }
      // 弹窗展示时候body高度为100vh
      if (!this.isKaniu && bodyHeight !== '100vh') {
        this.scrollTop = scrollTop
      }
    }, 10)
  }
}
